<template>
    <el-dialog
        :title="editId ? '编辑公海' : '新增公海'"
        :visible.sync="operatorDialogVisible"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        class="custom-form-dialog custom-high-seas-dialog"
    >
        <el-form
            ref="formData"
            :rules="formDataRules"
            :model="formData"
            label-position="top"
            v-loading="formLoading"
            class="custom-form-row"
        >
            <el-form-item label="公海名称" prop="seas_name">
                <el-input
                    v-model="formData.seas_name"
                    placeholder="请输入公海名称"
                    :maxlength="15"
                    show-word-limit
                ></el-input>
            </el-form-item>
            <el-form-item label="公海管理员" prop="admins">
                <template slot="label">
                    <p>
                        公海管理员<el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content">
                                公海管理员拥有对该公海客户全部操作权限<br />包含编辑、删除、申领、分配、转移、分享
                            </div>
                            <i class="iconfont icon-bangzhuzhongxin"></i>
                        </el-tooltip>
                    </p>
                </template>
                <div class="select-author-btn" @click="handleClickSelectAuthor('admins')">
                    <div>
                        <span :class="{ 'text-bold': authorizedAdminData && authorizedAdminData.length }">{{
                            authorizedAdminDataTxt || "点击授权"
                        }}</span>
                    </div>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </el-form-item>
            <el-form-item label="公海成员" prop="members">
                <template slot="label">
                    <p>
                        公海成员<el-tooltip class="item" effect="dark" placement="top-start">
                            <div slot="content">
                                1.公海成员可以对该公海客户进行查看、申领<br />
                                2.非公海成员对该公海不可见，不授权则公司全员可见
                            </div>
                            <i class="iconfont icon-bangzhuzhongxin"></i>
                        </el-tooltip>
                    </p>
                </template>
                <div class="select-author-btn" @click="handleClickSelectAuthor('members')">
                    <div>
                        <span :class="{ 'text-bold': authorizedMembersData && authorizedMembersData.length }">{{
                            authorizedMembersDataTxt || "点击授权"
                        }}</span>
                    </div>
                    <i class="el-icon-arrow-down"></i>
                </div>
            </el-form-item>
            <el-form-item label="申领上限设置" prop="daily_limit">
                <el-input
                    v-model="formData.daily_limit"
                    placeholder="请输入申领上限个数"
                    oninput="value=value.replace(/[^\d]/g,'')"
                ></el-input>
            </el-form-item>
            <p class="daily-limit-tip">设置每人每日申领客户最大数量，不设置默认不限制</p>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose" :disabled="btnDisabled">取消</el-button>
            <el-button type="primary" @click.stop="handleDialogConfirm" :disabled="btnDisabled">确定</el-button>
        </span>
        <!-- <AuthorizedPersonnel
            ref="AuthorizedPersonnel"
            :authorizedPersonnelVisible.sync="authorizedPersonnelVisible"
            :userDepartmentPostSelected.sync="userDepartmentPostSelected"
            @selectAuthorizedData="selectAuthorizedData"
            v-if="authorizedPersonnelVisible"
        /> -->
        <userDepartmentPostSelection :userDepartmentPostVisible.sync="authorizedPersonnelVisible" v-if="authorizedPersonnelVisible" :userDepartmentPostSelected="userDepartmentPostSelected" :selectType="'departmentUserTag'" :userDepartmentPostTitle="'授权人员'"  @success="selectAuthorizedData"/>
    </el-dialog>
</template>
<script>
import { HighSeasManagementAdd, HighSeasManagementEdit, HighSeasManagementDetail } from "@/api";
// import AuthorizedPersonnel from "@/components/pComponents/AuthorizedPersonnel.vue";
import userDepartmentPostSelection from "@/components/pComponents/userDepartmentPostSelection.vue";
export default {
    name: "HighSeasOperator",
    props: {
        operatorDialogVisible: {
            type: Boolean,
            default: false,
        },
        editId: {
            type: Number,
            default: 0,
        },
    },
    components: { 
        // AuthorizedPersonnel 
        userDepartmentPostSelection
    },
    data() {
        return {
            formData: {
                seas_name: "",
                admins: [],
                members: [],
                daily_limit: "",
            },
            formDataRules: {
                seas_name: [{ required: true, message: "请输入公海名称", trigger: "blur" }],
                admins: [{ required: true, message: "请选择公海管理员", trigger: "change" }],
            },
            formLoading: true,
            btnDisabled: false,
            authorizedPersonnelVisible: false,
            userDepartmentPostSelected: [],
            authorizedType: "", // 管理员还是成员
            authorizedAdminData: [], // 选择的管理员
            authorizedMembersData: [], // 选择的成员
        };
    },
    computed: {
        authorizedAdminDataTxt() {
            const list = this.authorizedAdminData;
            
            if (list && list.length) {
                const departmentData = list.filter((item) => item.relate_type == "App\\Models\\Department"); // 部门
                const memberData = list.filter((item) => item.relate_type == "App\\Models\\User"); // 人员
                const tagData =  list.filter((item) => item.relate_type == "App\\Models\\UserTagRelate"); // 人员标签
                let txt = "";
                if (departmentData && departmentData.length) {
                    txt += `${departmentData.length}个部门`;
                }
                if (memberData && memberData.length) {
                    txt += `${memberData.length}个人员`;
                }
                if (tagData && tagData.length) {
                    txt += `${tagData.length}个标签`
                }
                return txt;
            } else {
                return "";
            }
        },
        authorizedMembersDataTxt() {
            const list = this.authorizedMembersData;
            if (list && list.length) {
                const departmentData = list.filter((item) => item.relate_type == "App\\Models\\Department"); // 部门
                const memberData = list.filter((item) => item.relate_type == "App\\Models\\User"); // 人员
                const tagData =  list.filter((item) => item.relate_type == "App\\Models\\UserTagRelate"); // 人员标签
                let txt = "";
                if (departmentData && departmentData.length) {
                    txt += `${departmentData.length}个部门`;
                }
                if (memberData && memberData.length) {
                    txt += `${memberData.length}个人员`;
                }
                if (tagData && tagData.length) {
                    txt += `${tagData.length}个标签`
                }
                return txt;
            } else {
                return "";
            }
        },
    },
    created() {
        this.getHighSeasManagementDetail();
    },
    methods: {
        getHighSeasManagementDetail() {
            if (this.editId) {
                HighSeasManagementDetail(this.editId, {})
                    .then((res) => {
                        if (res.code == 200) {
                            const { data } = res;
                            this.$set(this.formData, "seas_name", data.seas_name);
                            this.$set(this.formData, "admins", data.admins);
                            this.$set(this.formData, "members", data.members);
                            this.$set(this.formData, "daily_limit", data.daily_limit);
                            this.authorizedAdminData = data.admins.map(item=> {
                                if(!item.relate_type_id) {
                                    item.relate_type_id = item.relate_id + '_' +item.relate_type
                                }
                                return item
                            });
                            this.authorizedMembersData = data.members.map(item=> {
                                if(!item.relate_type_id) {
                                    item.relate_type_id = item.relate_id + '_' +item.relate_type
                                }
                                return item
                            });
                        }
                    })
                    .finally(() => {
                        this.formLoading = false;
                    });
            } else {
                this.formLoading = false;
            }
        },
        // 去选择
        handleClickSelectAuthor(authorizedType) {
            this.authorizedType = authorizedType;
            if (this.authorizedType == "admins") {
                this.userDepartmentPostSelected = JSON.parse(JSON.stringify(this.authorizedAdminData));
            } else {
                this.userDepartmentPostSelected = JSON.parse(JSON.stringify(this.authorizedMembersData));
            }
            this.authorizedPersonnelVisible = true;
        },
        // 回显
        selectAuthorizedData(data) {
            if (this.authorizedType == "admins") {
                // 管理员
                this.authorizedAdminData = data;
                this.formData.admins = data;
                if (data.length) {
                    this.$refs.formData.clearValidate(["admins"]);
                }
            } else {
                // 成员
                this.authorizedMembersData = data;
                this.formData.members = data;
                if (data.length) {
                    this.$refs.formData.clearValidate(["members"]);
                }
            }
        },
        handleDialogClose() {
            this.$emit("update:operatorDialogVisible", false);
        },
        handleDialogConfirm() {
            this.$refs.formData.validate((valid) => {
                if (valid) {
                    const data = {
                        seas_name: this.formData.seas_name,
                        admins: this.authorizedAdminData,
                        members: this.authorizedMembersData,
                        daily_limit: this.formData.daily_limit,
                    };
                    this.btnDisabled = true;
                    if (this.editId) {
                        // 编辑
                        HighSeasManagementEdit(this.editId, data).then((res) => {
                            if (res.code == 200) {
                                this.btnDisabled = false;
                                this.$message.success("操作成功！");
                                this.$emit("update:operatorDialogVisible", false);
                                this.$emit("operatorSuccessCallback");
                            } else {
                                this.btnDisabled = false;
                                this.$message.error(res.message);
                            }
                        });
                    } else {
                        // 新增
                        HighSeasManagementAdd(data).then((res) => {
                            if (res.code == 200) {
                                this.btnDisabled = false;
                                this.$message.success("操作成功！");
                                this.$emit("update:operatorDialogVisible", false);
                                this.$emit("operatorSuccessCallback");
                            } else {
                                this.btnDisabled = false;
                                this.$message.error(res.message);
                            }
                        });
                    }
                }
            });
        },
    },
};
</script>
<style lang="scss">
.custom-high-seas-dialog {
    .el-dialog__body {
        max-height: 492px;
        overflow-y: scroll;

        .el-form-item__label {
            p {
                display: inline;
                letter-spacing: 0;
            }

            .iconfont {
                margin-left: 4px;
                padding: 4px;
                font-size: 14px;
                color: rgba(102, 102, 102, 1);
                cursor: pointer;

                &:hover {
                    border-radius: 4px;
                    background: rgba(0, 0, 0, 0.04);
                    color: rgba(51, 51, 51, 1);
                }
            }
        }
    }

    .select-author-btn {
        width: 100%;
        height: 32px;
        padding: 12px;
        opacity: 1;
        border-radius: 4px;
        background: #ffffff;
        border: 1px solid #d9d9d9;
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        line-height: 22px;
        color: rgba(153, 153, 153, 1);
        cursor: pointer;

        .el-icon-arrow-down {
            color: #666666;
        }

        &:active {
            border-color: #409eff;
        }

        .text-bold {
            color: rgba(51, 51, 51, 1);
        }
    }

    .label-tip-txt {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
    }

    .daily-limit-tip {
        font-size: 12px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 18px;
        color: rgba(153, 153, 153, 1);
        margin-top: -14px;
    }
}
</style>
